<template>
  <div
    :class="[
      'component-accordion',
      'component-accordion--' + type,
      { 'border-bottom': borderBottom },
      { 'border-top': borderTop }
    ]"
  >
    <div class="component-accordion__title" @click.prevent="active = !active">
      {{ title }}
      <div v-if="type == 'default'">
        <i v-show="!active" class="icon-plus"></i>
        <i v-show="active" class="icon-minus"></i>
      </div>
      <div v-if="type == 'small'">
        <i v-show="!active" class="icon-caret"></i>
        <i v-show="active" class="icon-caret-up"></i>
      </div>
    </div>
    <div v-show="active" class="component-accordion__content">
      <span v-if="text" v-html="text"></span>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqAccordion',
  components: {},
  props: {
    title: {
      type: String
    },
    text: {
      type: String
    },
    type: {
      type: String,
      default: 'default'
    },
    borderBottom: {
      type: Boolean,
      default: false
    },
    borderTop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false
    }
  }
}
</script>

<style lang="scss">
.component-accordion {
  padding-top: calc(#{rem(40px)}* var(--scale-spacing));
  padding-bottom: calc(#{rem(40px)}* var(--scale-spacing));

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* IE10+ CSS styles go here */
    padding-top: rem(40px);
    padding-bottom: rem(40px);
  }

  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    font-weight: 500;
    letter-spacing: rem(-0.5px);
    font-size: rem(20px);

    i {
      color: $blue-900;
      margin-left: 0.66rem;
    }
  }

  &__content {
    font-size: rem(18px);
    line-height: 1.75;
    color: $gray-700;
    padding-top: calc(#{rem(40px)}* var(--scale-spacing));

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      /* IE10+ CSS styles go here */
      padding-top: rem(40px);
    }
  }

  // .icon-width {
  //   width: 5rem !important;
  // }

  &--small {
    padding-top: calc(#{rem(16px)}* var(--scale-spacing));
    padding-bottom: calc(#{rem(16px)}* var(--scale-spacing));

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      /* IE10+ CSS styles go here */
      padding-top: rem(16px);
      padding-bottom: rem(16px);
    }

    .component-accordion__title {
      justify-content: flex-start;
      font-size: rem(20px);
      color: $blue-900;

      i {
        font-size: 75%;
      }
    }

    .component-accordion__content {
      font-size: rem(16px);
      padding-top: calc(#{rem(16px)}* var(--scale-spacing));

      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        /* IE10+ CSS styles go here */
        padding-top: rem(16px);
      }
    }
  }
}
</style>
